import { CustomerStatusType } from 'api/user-domain/user-domain.types';

interface ICustomerStatus {
  [key: string]: CustomerStatusType;
}

export const CustomerStatus: ICustomerStatus = {
  VERIFIED: 'VERIFIED',
  VERIFICATION_PENDING: 'VERIFICATION_PENDING',
  INCOMPLETE_PROFILE: 'INCOMPLETE_PROFILE',
};
